import EnrollUnEnrollBtn from "./EnrollUnEnrollBtn";
import CertificateReqBtn from "./CertificateReqBtn";
import Header from "./Header";

const Partials = {
  EnrollUnEnrollBtn,
  CertificateReqBtn,
  Header,
};

export default Partials;
